export const environment = {
  production: true,
  buildId: '3099131724220471',
  configFile: 'config.json',
};
